<template>
  <v-dialog v-model="dialog" persistent max-width="350">
    <template v-slot:activator="{ on }">
      
        <div @click.stop="dialog = true">
          <slot @click.stop="dialog = true" name="action">
            </slot>
        </div>
    </template>
    <v-card>
      <v-card-title class="headline">{{headline ? headline : $t('warning')}}</v-card-title>
      <v-card-text>{{message ? message : $t('areYouSure')}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  text autofocus @click="dialog = false">{{cancelbuttonText}}</v-btn>
        <v-btn large depressed color="secondary" @click="remove(id,fk)">{{actionButtonText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  props: {
    object: String,
    id: String,
    icon: Boolean,
    button: Boolean,
    fk: String,
    small: Boolean,
    text: String,
    headline:String,
    message:String,
    list_item: Boolean,
    cancelbuttonText: {
      type: String,
      default: 'no'
    },
    actionButtonText: {
      type: String,
      default: 'yes'
    },
    color: {
      type: String,
      default: "error"
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    remove(id, fk) {
      switch (this.object) {
        case "project":
          this.$http
            .deleteProject(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "buildingComponent":
          this.$http
            .deleteBuildingComponents(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "blueprint":
          this.$http
            .deleteBlueprint(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "marker":
          // code block
          this.$http
            .deleteMarker(id)
            .then(rs => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "attachment":
          // code block
          this.$http
            .deleteAttachment(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "attribute":
          // code block
          this.$http
            .deleteAttribute(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("deleteAttribute", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "attributeValue":
          // code block
          this.$http
            .deleteValues(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("deleteValue", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "solution":
          // code block
          break;
        case "solutionXproduct":
          if (fk !== "") {
            this.$http
              .deleteSolutionXproduct(id, fk)
              .then(res => {
                this.$noty.success('<i class="fas fa-check"></i>');
                this.$emit("deleteSolutionXproduct", fk);
                this.dialog = false;
              })
              .catch(err => {
                this.$noty.error(this.$t("error"));
                console.log(err);
              });
          }

          break;
        case "installer":
          // code block
          break;
        case "productAttachment":
          this.$http
            .deleteProductAttachment(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "report":
          this.$http
            .deleteReport(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
        default:
          this.$emit("delete");
          this.dialog = false;
      }
      this.dialog = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AreYouSure2.vue